import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
    Link,
    Card,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Container,
    Typography,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    Grid
} from '@mui/material';
import { ListHead, ListToolbar, MoreMenu } from '../../components/_dashboard/car';
import { LoadingButton } from '@mui/lab';
import Scrollbar from '../../components/Scrollbar';
import { fetchAllAccounts } from '../../actions/accountAction';
import _ from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';
import Edit from "@material-ui/icons/Edit";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalCompoennt from '../Portal/ModalCompoennt';
import AddAccount from './AddAccount';
import UpdateAccount from './UpdateAccount';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

const TABLE_HEAD = [
    { id: 'title', label: 'Title', alignRight: false },
    { id: 'account_no', label: 'Account Number', alignRight: false },
    { id: 'bank_name', label: 'Bank Name', alignRight: false },
    { id: 'branch_name', label: 'Branch_name', alignRight: false },
    { id: 'actions', label: 'Action', alignRight: false },

];

function AccountList(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [adminObj, setAdminObj] = useState({});
    const [openUpdate, setOpenUpdate] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [updateOpen, setUpdateOpen] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [accountObj, setAccountObj] = useState({});

    useEffect(() => {
        setIsLoading(false);
    }, [props.alerts]);

    useEffect(() => {
        props.fetchAllAccounts();
    }, []);

    const handleUpdateClick = (a) => {
        setUpdateOpen(true);
        setAccountObj(a);
    }

    const handleAddClick = () => {
        setAddOpen(true);
    }
    
    const closeButton = () => {
        setUpdateOpen(false);
        setAddOpen(false);
        setAccountObj({});
    }

    const renderAccountList = () => {
        if(!_.isEmpty(props.accounts)) {
            var accounts = props.accounts;
            return accounts.map((a) => {
                return (
                    <TableRow
                        hover
                        tabIndex={-1}
                    >
                        <TableCell align="left" style={{padding:"10px"}}>{a.title}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{a.account_no}</TableCell>
                        <TableCell alig n="left" style={{padding:"10px"}}>{a.bank_name}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{a.branch_name}</TableCell>
                        <TableCell colSpan={3}>
                            <IconButton onClick={() => handleUpdateClick(a)} sx={{float:"left",padding:"0px", color:"#c29136"}}>
                                <Edit />
                            </IconButton>
                            <IconButton sx={{float:"left",padding:"0px", color:"#c29136"}}>
                                <DeleteOutlined />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                );
            })
        } else {
            return <TableRow>
                <TableCell>No Account Exist</TableCell>
            </TableRow>
        }
    }

    return (
        <Page title="Account List">
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Grid>
                    <Typography variant="h4" gutterBottom>
                        Account List 
                    </Typography>
                </Grid>
                <Grid>
                    <LoadingButton
                        fullWidth
                        size="medium"
                        type="submit"
                        variant="contained"
                        loading={isLoading}
                        sx={{backgroundColor: '#c29136',}}
                        onClick={() => handleAddClick()}
                    >
                        Add Account
                    </LoadingButton>
                </Grid>
            </Stack>
            <Card>
                <Scrollbar>
                    <TableContainer sx={{ minWidth: 800 }}>
                        <Table>
                            <ListHead
                                headLabel={TABLE_HEAD}
                                rowCount={props.accounts.length}
                            />
                            <TableBody>
                                {renderAccountList()}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Card>
            {
                addOpen && 
                <ModalCompoennt open={addOpen} onClose={closeButton} title="Create Account" width="lg">
                    <AddAccount onDismis={closeButton} />
                </ModalCompoennt>
            }
            {
                updateOpen && 
                <ModalCompoennt open={updateOpen} onClose={closeButton} title="Update Account" width="lg">
                    <UpdateAccount onDismis={closeButton} account={accountObj} />
                </ModalCompoennt>
            }
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
        accounts: Object.values(state.accounts.data),
    }
}

export default connect(mapStateToProps, { fetchAllAccounts })(AccountList);

